import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import routes from '../../../routes';

@inject('authenticationStore')
@observer
class ErrorBoundary extends Component {

  static propTypes = {
    authenticationStore: PropTypes.shape({
      hasAuthenticationToken: PropTypes.bool,
    }),
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    authenticationStore: {
      hasAuthenticationToken: false
    }
  };

  render() {
    const { authenticationStore: { hasAuthenticationToken }, children } = this.props;
    return (
      <div className="error-boundary">
        {!hasAuthenticationToken && (
          <Redirect from="/" exact to={routes.authentication} />
        )
        }
        {children}
      </div>
    );
  }
}
export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/common/components/error-boundary/error-boundary.component.js